/**
 * Accordion for SDS page
 */
const sdsAcc = () => {
  const accButtons = document.querySelectorAll('.js-acc-btn') as NodeListOf<HTMLElement>;
  const accCloseButtons = document.querySelectorAll('.js-acc-sub') as NodeListOf<HTMLElement>;

  //@ts-ignore
  const toggleAccordion = (button, content) => {
    button.classList.toggle('active');
    content.classList.toggle('active');
    content.style.maxHeight = content.style.maxHeight ? null : content.scrollHeight + 'px';
  };

  accButtons.forEach((button) => {
    button.addEventListener('click', function () {
      //@ts-ignore
      const accContent = this.closest('.sds__row').querySelector('.js-acc-content');
      if (accContent) {
        //@ts-ignore
        toggleAccordion(this, accContent);
      }
    });
  });

  accCloseButtons.forEach((button) => {
    button.addEventListener('click', function () {
      //@ts-ignore
      const accRow = this.closest('.sds__row');
      const accContent = accRow!.querySelector('.js-acc-content');
      const accBtn = accRow!.querySelector('.js-acc-btn');

      if (accContent && accBtn) {
        accBtn.classList.remove('active');
        accContent.classList.remove('active');
        //@ts-ignore
        accContent.style.maxHeight = null;
      }
    });
  });
};

export default sdsAcc;
